import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import { getAllRequests, getAllCategories, getUserById } from "../../apis";
import {
  Container,
  Stack,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Typography,
} from "@mui/material";
import FeedRequestCard from "./components/FeedRequestCard";
import SelectedRequest from "./components/SelectedRequest";
import FeedsSkeleton from "./components/FeedsSkeleton";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

const Feeds = () => {
  const [allRequests, setAllRequests] = useState([]);
  const [category, setCategory] = useState("");
  const [distance, setDistance] = useState("");
  const [price, setPrice] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // const categories = [
  //   { label: "AC Services", value: "AC Services" },
  //   { label: "Cleaning Services", value: "Cleaning Services" },
  //   { label: "Salon and Self Care", value: "Salon and Self Care" },
  //   { label: "Plumbing Services", value: "Plumbing Services" },
  //   { label: "Electrician Services", value: "Electrician Services" },
  //   { label: "Appliances Maintenance", value: "Appliances Maintenance" },
  //   { label: "Packaging and Movers", value: "Packaging and Movers" },
  //   { label: "Pest Control", value: "Pest Control" },
  // ];

  const km = [
    // { value: 1, label: "1 kilometer" },
    // { value: 2, label: "2 kilometers" },
    { value: 5, label: "5 miles" },
    { value: 10, label: "10 miles" },
    { value: 20, label: "20 miles" },
    { value: 40, label: "40 miles" },
    { value: 60, label: "60 miles" },
    { value: 80, label: "80 miles" },
    { value: 100, label: "100 miles" },
    // { value: 250, label: "250 kilometers" },
    // { value: 500, label: "500 kilometers" },
  ];

  function distanceCalc(lat1, lon1, lat2, lon2, unit) {
    if (lat1 == lat2 && lon1 == lon2) {
      return 0;
    } else {
      var radlat1 = (Math.PI * lat1) / 180;
      var radlat2 = (Math.PI * lat2) / 180;
      var theta = lon1 - lon2;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit == "K") {
        dist = dist * 1.609344;
      }
      if (unit == "N") {
        dist = dist * 0.8684;
      }
      return dist;
    }
  }

  useEffect(() => {
    const getData = async () => {
      const response = await getAllRequests();
      setAllRequests(response.data.requests);
      setLoading(false);
      const result = await getAllCategories();
      setCategoriesData(result.data.categories);
      let arr = [];
      result.data.categories.map((item) => {
        arr.push({ label: item.name, value: item.name });
      });
      setCategories(arr);
    };
    getData();
  }, []);

  const handleCategoryChange = async (event) => {
    setLoading(true);
    setCategory(event.target.value);
    const response = await getAllRequests();
    const filteredrequests = response.data.requests.filter(
      (item) => item.category == event.target.value
    );

    setAllRequests(filteredrequests);
    setLoading(false);
  };

  const handleDistanceChange = async (event) => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user-info"));
    const userID = user.googleId ? user.googleId : user._id;
    const res = await getUserById(userID);
    const userLat = res.data.serviceProviderInfo.personalInfo.latitude;
    const userLong = res.data.serviceProviderInfo.personalInfo.longitude;
    let filteredrequests = [];
    allRequests.map((item) =>
      getGeocode({ address: item.address }).then((results) => {
        const { lat, lng } = getLatLng(results[0]);
        let response = distanceCalc(lat, lng, userLat, userLong, "K");
        if (response <= event.target.value) {
          filteredrequests.push(item);
        }
      })
    );
    setAllRequests(filteredrequests);
    setLoading(false);
  };

  const RequestClickhandler = (id) => {
    const filteredResult = allRequests.filter((item) => item._id == id);
    setSelectedRequest(filteredResult[0]);
  };

  return (
    <>
      <Navbar />
      {/* <Container> */}
      <Grid container>
        <Grid item sm={6}>
          <Container>
            <Stack direction="row" spacing={4} className="ml-16">
              <h2>Requests</h2>
              <Stack direction="row" spacing={4} alignItems="center">
                <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={category}
                      onChange={handleCategoryChange}
                      autoWidth
                    >
                      <MenuItem disabled value="">
                        <em>Category</em>
                      </MenuItem>
                      {categories.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={distance}
                      onChange={handleDistanceChange}
                    >
                      <MenuItem disabled value="">
                        <em> Distance</em>
                      </MenuItem>
                      {km.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                {/* <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={price}
                      onChange={handleCategoryChange}
                    >
                      <MenuItem disabled value="">
                        <em> Price</em>
                      </MenuItem>
                      {categories.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack> */}
                {/* <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={sortBy}
                      onChange={handleCategoryChange}
                    >
                      <MenuItem disabled value="">
                        <em>Sort by</em>
                      </MenuItem>
                      {categories.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack> */}
              </Stack>
            </Stack>
            <div
              style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
              className="mb-16 ml-16"
            >
              <Stack spacing={2}>
                {allRequests.length && !loading ? (
                  allRequests.map((request) => (
                    <FeedRequestCard
                      title={request.title}
                      location={request.address}
                      fromDate={request.fromDate}
                      urgent={request.urgent}
                      details={request.details}
                      id={request._id}
                      clickHandler={RequestClickhandler}
                    />
                  ))
                ) : !loading && !allRequests.length ? (
                  <Typography>No requests found</Typography>
                ) : (
                  <>
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                  </>
                )}
              </Stack>
            </div>
          </Container>
        </Grid>
        <Grid item sm={6}>
          {selectedRequest != null ? (
            <SelectedRequest currentRequest={selectedRequest} />
          ) : null}
        </Grid>
      </Grid>
      {/* </Container> */}
    </>
  );
};

export default Feeds;
